import Cookies from 'js-cookie';

import { getCookieDomain } from '../utils';

const SET_ID = 'formlabs/store/SET_ID';
const NOOP = 'formlabs/store/NOOP';

const initialState = {
  id: 'us_en'
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ID:
      return { ...state, id: action.payload };
    case NOOP:
      return state;
    default:
      return state;
  }
}

export const setStoreId = id => {
  Cookies.set('store_view', id, { domain: getCookieDomain() });
  return {
    type: SET_ID,
    payload: id
  };
};

export const checkStoreId = (fallbackLanguage, fallbackRegion) => {
  return async (dispatch, getState) => {
    const {
      store: { id },
      i18n: { language, region }
    } = getState();

    const desiredStoreId =
      language && region
        ? `${region}_${language}`
        : `${fallbackRegion}_${fallbackLanguage}`;

    // Update redux store id when region changed or initial visit
    if (desiredStoreId !== id) {
      dispatch(setStoreId(desiredStoreId));
    }

    // Edge Case. Also set cookie value for default store id
    if (!Cookies.get('store_view')) {
      dispatch(setStoreId(desiredStoreId));
    }
  };
};
